<template>
   <!--<div>

    <div class="divButtonRigth" style="margin-bottom: 20px">
     <el-col >
        <el-button type="primary" size="small" @click="toCompanyPage()" >公司设置</el-button>>>>
        <el-button type="primary" size="small" @click="toPayGroupPage()">薪酬组</el-button>>>>
        <el-button type="primary" size="small" @click="toSalaryTemplatePage()">工资模板</el-button>>>>
        <el-button type="primary" size="small" @click="toPayrollPage()">工资单</el-button>
      </el-col>
    </div>-->

        <div class="customer-info">
      <div class="customer-info-item" >
        <div class="customer-info-title">
          <!--图标-->
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-qiyexinxi"></use>
          </svg>
          <span>工资模板</span>
        </div>

        <div class="filter-container">
          <el-link type="primary" @click="toEditPage()" style="margin-right:10px;">新增</el-link>
           <el-link type="primary" @click="changeStatus('90110001')" style="margin-right:10px;">启用</el-link>
            <el-link type="primary" @click="changeStatus('90110002')" >禁用</el-link>
        </div>
      </div>
    <div style="padding:10px 40px">
    <bsp-table
      ref="configCenterTable"
      :data.sync="list"
      :ciic-data-filter.sync="listQuery"
      @ciic-data-refresh="_getSalaryTemplatelList"
      @select-change="selectChange"
      @select-all="selectAll"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      show-overflow
      :showPagination="false"
    >

      <vxe-table-column type="selection" width="60" fixed="left" align="center" ></vxe-table-column>
      <vxe-table-column title="序号" type="index" width="60" fixed="left" align="center"></vxe-table-column>
      <bsp-table-column field="id"  filter-type="input" sortable :visible="false">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        title="名称"
        field="templateName"
        filter-type="input"
        width="300"  fixed="left"
      >
        <template slot-scope="scope">
          <span>{{scope.row.templateName}}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column
        field="taxType"
        filter-type="select"
        title="计税类型"
        set-id="9245"
        multiple="true"
        width="400"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.taxType |bspTableFilter({'1':'dict', '2':dicts})  }}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column
        title="薪酬组"
        field="wageGroupId"
        v-if="this.payGroupData.length>0"
        :options-list="payGroupData"
        :optionProps="defaultProps"
        width="500"
      >
        <template slot-scope="scope">
          <span>{{scope.row.wageGroupId |bspTableFilter({'1':'refs', '3':groupsMap})}}</span>
        </template>
      </bsp-table-column>

      <!-- <bsp-table-column
        title="算薪规则"
        field="calType"
        filter-type="select"
        set-id="9247"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{scope.row.calType | dictFilter(dicts)}}</span>
        </template>
      </bsp-table-column> -->


      <bsp-table-column
        title="状态"
        field="status"
        filter-type="select"
        set-id="9011"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{scope.row.status | dictFilter(dicts)}}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        title="创建人"
        field="createName"
        width="200"
      >
        <template slot-scope="scope">
          <span>{{scope.row.createName}}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        title="创建时间"
        field="bizCreateTime"
        width="300"
      >
        <template slot-scope="scope">
          <span>{{scope.row.bizCreateTime}}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column
        title="操作" fixed="right" width="200"
      >
        <template slot-scope="scope">
          <div class="ciic-table-operate">
            <el-button size="small" type="text" @click="onCopyClick(scope.row.id)">
              复制
            </el-button>
            <el-button size="small" type="text" @click="toEditPage(scope.row.id)">
              编辑
            </el-button>
            <el-button size="small" type="text" @click="toDetailPage(scope.row)">
              详情
            </el-button>
          </div>
        </template>
      </bsp-table-column>
    </bsp-table>
</div>
    <!-- 新增和修改 -->
    <el-dialog
      :title="infoDialogTitle"
      :visible.sync="infoDialogVisible"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px;"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="rules"
        class="editForm"
        label-width="150px"
        label-suffix="："
        v-loading="infoLoading"
      >
        <el-form-item label="工资表名称" prop="templateName" style="margin-bottom: 30px;">
          <el-input v-model="form.templateName"  @change="_changeName($event)" placeholder="工资表名称"></el-input>
        </el-form-item>

        <!-- <el-form-item label="倒算" prop="calType">
          <el-radio-group v-model="form.calType" :disabled="disabled">
            <el-radio :label="'92470001'">正算</el-radio>
            <el-radio :label="'92470002'">(含)倒算</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <el-form-item label="计税类型" prop="taxType" v-if="infoDialogTitle != '复制工资表'">
<!--          <el-select  v-model="form.taxType" :disabled="this.state" multiple="true" placeholder="请选择计税类型">-->
<!--            <el-option-->
<!--              v-for="item in this.dicts.codeList[9245]"-->
<!--              :key="item.codeItemId"-->
<!--              :label="item.codeItemName"-->
<!--              :value="item.codeItemId">-->
<!--            </el-option>-->
<!--          </el-select>-->
          <bsp-dicts-select
            ref="taxType"
            v-model="form.taxType"
            dic-num="9245"
            remNum="92450002,92450004,92450007"
            :multiple="true"
            :disabled="disabled"
            @selectChange="selectChangeTaxType"
            placeholder="计税类型"
          />
        </el-form-item>
        <el-form-item label="薪酬组" prop="wageGroupId">
<!--          <el-select v-model="form.wageGroupId "  multiple="true"  placeholder="请选择薪酬组">-->
<!--            <el-option-->
<!--              v-for="item in payGroupData"-->
<!--              :key="item.value"-->
<!--              :label="item.name"-->
<!--              :value="item.value">-->
<!--            </el-option>-->
<!--          </el-select>-->
          <ciic-tree-select  ref="wageGroupId" :multiple="true" :props="defaultGroupProps" :expand="true" :showFilter="false" :options="payGroupTreeData"
                            :value="form.wageGroupId" @getValue="selectWageGroup" placeholder="请选择薪酬组"></ciic-tree-select>
        </el-form-item>

        <!--<el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="'90110001'">启用</el-radio>
            <el-radio :label="'90110002'">禁用</el-radio>
          </el-radio-group>
        </el-form-item>-->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveOrUpdate('form')">确 定</el-button>
        <el-button @click="cancelHandler('form')">取 消</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import BspTable from "@/components/bsp/bsp-table/bsp-table";
  import BspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import defaultInvoice from "@/components/bsp/bsp-dicts-invoice/default";
  import {comRequest,getSalaryTemplatelList,checkTemplateName,changeTemplateStatus} from  "@/api/wage/salaryTemplate";
  import {getPayGroupData,getWageGroupTree} from  "@/api/wage/payGroup";
  import { mapGetters } from 'vuex';
  import CiicTreeSelect from "@/components/ciic/ciic-tree-select/ciic-tree-select";
  import bspDictsSelect from "@/components/bsp/bsp-dicts-select/bsp-dicts-select";
  import {deepCopy} from "@/util/util";

  export default {
    name: 'salaryTemplateList',
    computed: {
      ...mapGetters([
        'dicts',
      ]),
    },
    components: {
      BspTable,
      BspTableColumn,
      defaultInvoice,
      CiicTreeSelect,
      bspDictsSelect
    },
    created() {
      this._getPayGroupData();
      this._getSalaryTemplatelList();
      this._getWageGroupTree();
    },
    data() {
      return {
        role:{
          name: 'admin',
          tenantId: 'sys'
        },
        defaultProps:{
          value: 'id',
          label: 'groupName'
        },
        loading: false,
        // 弹框状态
        dialogStatus: 'add',
        dialogFormVisible: false,
        listForm:{},
        infoDialogTitle: "",
        infoDialogVisible: false,
        modelName: "salaryTemplate",
        state:false,
        //分页查询对象
        listQuery: {
          limit: 20,
          page: 1,
          total: 0,
          tenantId: '',
        },
        list:[],
        form:{
          templateName:"",
          taxType:[],
          wageGroupId:[],
          calType:92470001,
          status:""
        },
        multipleSelection: [],
        payGroupData:[],
        payGroupTreeData:[],
        oldFormData:{},
        editList:[true,false],
        groupsMap:{},
        rules: {
          templateName: [
            { required: true, message: '请输入工资表名称', trigger: 'blur' },
            { max:20, message: '不能超过20个字符', trigger:"blur"}
          ],
          calType: [
            { required: true, message: '请选择是否倒算', trigger: 'blur' }
          ],
          taxType: [
            { required: true, message: '请选择计税类型', trigger: 'blur' }
          ],
         wageGroupId: [
            { required: true, message: '请选择薪酬组',validator:this.checkWageGroupId, trigger: 'blur' }
          ],
          status: [
            { required: true, message: '请选择状态', trigger: 'blur' }
          ],
        },
        defaultGroupProps: {
            children: 'children',
            label: 'groupName',
            value:'id',
        },
        disabled:false,
      }
    },
    methods: {
      //将下拉list转换为翻译用的map
     setMapForList(e) {
        let datas = e;
        let map = {};
        for (let i = 0,l=datas.length; i <l; i++) {
          map[datas[i].value]=datas[i].name;
        }
        console.log("薪酬组list转换map-----",map);
        this.groupsMap =  map;
      },
      _changeName(e) {
        let name = e;
        checkTemplateName(name).then((res) => {
          console.log("校验模板-----",res.data.data.state);
          if(res.data.data.state=="false"){
            this.form.templateName = "";
            this.$message.error("工资模板名称已存在,请重新输入");
          }
        });
      },

      //批量更改状态
      selectChange({checked, row}){
        if(checked){
          this.multipleSelection.push(row)
        }
        if(!checked){
          this.multipleSelection.filter((item,index) => {
            if(item===row){
              this.multipleSelection.splice(index,1)
            }
          })
        }
        console.log(JSON.stringify(this.multipleSelection))
      },
      //复选框全选事件
      selectAll({checked, selection}){
        this.multipleSelection = selection;
        console.log("全选-----",JSON.stringify(this.multipleSelection))
      },
      changeStatus(status){
        let listSize=this.multipleSelection.length;
        if(listSize==0){
          this.$message.error('请选择至少选中一行')
        }else{
          let param={
            multipleSelection: this.multipleSelection,
            status: status
          }
          changeTemplateStatus(param).then(res =>{
            if(res.data.code==0){
              this.$message.success(res.data.msg)
              this._getSalaryTemplatelList();
            }else{
              this.$message.error(res.data.msg)
            }
          })
        }
      },
      // 查询薪酬组
      _getPayGroupData() {
        getPayGroupData(this.listQuery).then((res) => {
          console.log("薪酬组List====",res.data.data)
          this.payGroupData = res.data.data
          this.oldFormData = res.data.data
          this.setMapForList(this.payGroupData);
        });
      },
      //表单查询薪酬组树
      _getWageGroupTree(){
          getWageGroupTree(this.cusId).then(res=>{
              this.payGroupTreeData = res.data.data;//查询机构树
          })
      },
      // 分页查询
      _getSalaryTemplatelList() {
        this.multipleSelection = [];
        this.loading=true;
        getSalaryTemplatelList(this.listQuery).then((res) => {
          console.log("2020-01-10--getConfigCenterList====",res)
          this.listQuery.total = res.data.data.total
          this.list = res.data.data.records
          this.loading=false
          // console.log('当前CodeItem分页对象为：'+JSON.stringify(this.list))
        }).catch(err=>{
          this.loading=false
        });
      },
      showAddDailog() {
        this.listForm = {
          codeItemStatus:1,
        };
        this.dialogFormVisible = true;
        this.dialogStatus = 'add';
      },
      onCopyClick(id) {
        if(this.$refs.form){
            this.$refs.form.clearValidate();//新增前清空校验
        }
        if(this.$refs.taxType){
          this.$refs.taxType.selectedData = []
        }
        if(this.$refs.wageGroupId){
          this.$refs.wageGroupId.clearHandle();
        }

        this.infoDialogVisible = true;
        this.infoDialogTitle = "复制工资表";
        this.infoLoading = true;
        this.state = true;
        this.disabled = true;
        comRequest("get", this.modelName, id).then(res => {
          if (res.data.code === 0) {
            this.form = res.data.data;
            this.form.id = null;
            this.form.templateName = null;
            this.form.wageGroupId = this.setListTaxGroup(this.form.wageGroupId);
            this.form.taxType = this.setListTaxGroup(this.form.taxType);
            if(this.$refs.taxType){
              this.$refs.taxType.selectedData = this.form.taxType;
            }

            this.infoLoading = false;
          } else {
            this.$message.error("服务器异常");
            this.infoLoading = false;
          }
        });
      },
      toEditPage(id) {
        // 弹出新增或修改的页面
        this.infoDialogVisible = true;
        if (id) {
          if(this.$refs.form){
            this.$refs.form.clearValidate();//新增前清空校验
          }
          if(this.$refs.taxType){
            this.$refs.taxType.selectedData = []
          }
          if(this.$refs.wageGroupId){
            this.$refs.wageGroupId.clearHandle();
          }
          // id 存在
          this.infoDialogTitle = "修改工资表";
          this.infoLoading = true;
          this.state = false;
          this.disabled = false;

          comRequest("get", this.modelName, id).then(res => {
            if (res.data.code === 0) {
              this.form = res.data.data;
              this.tempTaxType = deepCopy(this.form.taxType);//校验计税类型是否改变用
              this.form.wageGroupId = this.setListTaxGroup(this.form.wageGroupId);
              this.form.taxType = this.setListTaxGroup(this.form.taxType);

              this.$refs.taxType.selectedData = this.form.taxType;
               console.log("编辑form----",this.form);
              /*const taxList = this.form.tax.split("/");
              pathItemArr.forEach((pathItem) => {

              });*/
              this.infoLoading = false;
            } else {
              this.$message.error("服务器异常");
              this.infoLoading = false;
            }
          });
        } else {
          this.disabled = false;
          // id 不存在
          this.infoDialogTitle = "新增工资模板";
          if(this.$refs.form){
            this.$refs.form.clearValidate();//新增前清空校验
          }
          this.form = {
            templateName:"",
            taxType:[],
            wageGroupId:[],
            calType:'92470001',
            status:""
          };
          if(this.$refs.taxType){
            this.$refs.taxType.selectedData = []
          }
          if(this.$refs.wageGroupId){
            this.$refs.wageGroupId.clearHandle();
          }
        }
      },
      setListTaxGroup(dataStr){
       let data = [];
       let arr =  dataStr.split(",");
        for (let i = 0,l=arr.length; i <l; i++) {
          data.push(arr[i]);
        }
        return data;
      },
      toDetailPage(row) {
        /*const query = {   //getDynamicFom参数
          cusId : row.cusId,
          tenantId:row.tenantId,
          operMode:row.operMode,
          businessLeader:row.businessLeader,
          businessDeptName:row.businessDeptName
        }*/
        if(row.status=='90110002'){
          this.$message.warning('该模板已经被禁用');
        }else{
          const query = {id: row.id,cusId:row.cusId}
          console.log("详情参数query=",query);
          this.$router.push({ path: '/wage/salaryItemDetail', query});
        }
      },

      saveOrUpdate(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log('submit!----');
            //校验计税类型是否改变
            let k = true;
            if(!this.tempTaxType){
              k=true;
            }else if(this.form.taxType.length != this.tempTaxType.split(',').length){
              k = false;
            }else{
              for (let j in this.form.taxType) {
                let tax = this.form.taxType[j];
                console.log(tax)
                if(this.tempTaxType.indexOf(tax) != -1){
                  continue;
                }else{
                  k = false;
                  break;
                }
              }
            }
            if(k){
              this.submitForm('n');
            }else{
              //是否初始化模板
              this.$confirm('计税类型已改变,是否初始化模板?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(()=>{
                this.submitForm('n');
              }).catch(()=>{
                this.submitForm('n');
              })
            }
          } else {

            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      submitForm(isInit) {
          if (this.form.id) {
            // 修改
            let taxStr = '';
            let groupStr = '';
            this.form.taxType.forEach(temp=>{
              taxStr+=temp+","
            });
            if(taxStr.length>0)
              taxStr = taxStr.substring(0,taxStr.length-1);
            this.form.taxType = taxStr;
            this.form.wageGroupId.forEach(temp=>{
                groupStr+=temp+","
            });
            if(groupStr.length>0)
                groupStr = groupStr.substring(0,groupStr.length-1);
            this.form.wageGroupId = groupStr;

            this.form['isInit'] = isInit;//是否重新初始化模板

            comRequest("put", this.modelName, this.form).then(res => {
              if (res.data.code === 0) {
                this.infoDialogVisible = false;
                this.$message.success("修改成功");
                this._getSalaryTemplatelList();
              } else {
                this.$message.error("服务器异常");
              }
            });
          } else {
            // 新增
            let taxStr = '';
            let groupStr = '';
            this.form.taxType.forEach(temp=>{
              taxStr+=temp+","
            });
            if(taxStr.length>0)
              taxStr = taxStr.substring(0,taxStr.length-1);
            this.form.taxType = taxStr;

              this.form.wageGroupId.forEach(temp=>{
                  groupStr+=temp+","
              });
              if(groupStr.length>0)
                  groupStr = groupStr.substring(0,groupStr.length-1);
              this.form.wageGroupId = groupStr;

            comRequest("post", this.modelName, this.form).then(res => {
              if (res.data.code === 0) {
                this.infoDialogVisible = false;
                this.$message.success("新增成功");
                this._getSalaryTemplatelList();
              } else {
                this.$message.error("服务器异常");
              }
            });
          }
      },
     /* toCompanyPage(){
        const query = {}
        console.log("编辑参数query=",query);
        this.$router.push({ path: '/wage/companyInfo', query});
      },
      toPayGroupPage(){
        const query = {}
        console.log("编辑参数query=",query);
        this.$router.push({ path: '/wage/payGroupList', query});
      },
      toSalaryTemplatePage(){
        const query = {}
        console.log("编辑参数query=",query);
        this.$router.push({ path: '/wage/salaryList', query});
      },
      toPayrollPage(){
        const query = {}
        console.log("编辑参数query=",query);
        this.$router.push({ path: '/wage/payroll-detail', query});
      },*/
      // 取消
      cancelHandler(formName) {
        this.resetForm(formName);
        this.$refs.form.resetFields();
        this.form = this.oldFormData;
        this.infoDialogVisible = false;
        //this.changeEdit(index);
      },
      changeEdit(index){
        let newValue;
        console.log("最新的值",this.form);
        console.log("旧的值",this.oldFormData);
        this.editList[index] === "true"?newValue = "false":newValue = "true";
        this.form= JSON.parse(JSON.stringify(this.oldFormData));
        this.$set(this.editList, index, newValue)
      },
      selectWageGroup({ valueId, valueTitle, name, node }){
          this.form.wageGroupId = valueId;
          return valueId;
      },
      selectChangeTaxType(taxType){
        this.form.taxType = taxType;
      },
      taxTypeFormat(taxType){//数组转换字符串
        let result = '';
        if(taxType){
          for (let i = 0; i <taxType.length ; i++) {
            result+=taxType[i]+','
          }
          result=result.substr(0,result.length-1)
        }
        return result;
      },
      checkWageGroupId(rule,value,callback){
        console.log(value)
        if(value==null || value.length==0){
          callback('请选择薪酬组')
        }else{
          callback()
        }
      }

    },

  }
</script>

<style scoped="scoped">
  #teanant-select{
    width: 100px;
  }
.editForm >>> .el-form-item__content{
	height: auto;
}
</style>
